import vFocusMode from "./v-focus-mode.vue";

export default Vue => {
  Vue.component("v-focus-mode", vFocusMode);
};
